// extracted by mini-css-extract-plugin
export var baseButton = "_vv-0";
export var controlsArrowKeys = "_vv-1";
export var controlsResetButton = "_vv-2";
export var lightGameButton = "_vv-4 _vv-0";
export var playAgainButton = "_vv-5 _vv-0";
export var startGameButton = "_vv-3 _vv-0";